module.exports = __webpack_public_path__ + "static/media/tools_02_small.e3ef0852.jpg";